import { createSlice } from "@reduxjs/toolkit";
import notesProvider from "../providers/notesProvider";

const initialState = {
	selectedNote: {},
	isSaving: false,
	isLoading: false,
	isEditable: true,
	notesPanelWidth: notesProvider.getNotesPanelWidth() || 35,
	isGenerating: false,
	newlyGeneratedNote: 0,
	openDrawer: false,
};
const noteSlice = createSlice({
	name: "note",
	initialState,
	reducers: {
		setSelectedNote: (state, { payload }) => ({ ...state, selectedNote: payload }),
		setIsSaving: (state, { payload }) => ({ ...state, isSaving: payload }),
		setIsLoading: (state, { payload }) => ({ ...state, isLoading: payload }),
		setIsEditable: (state, { payload }) => ({ ...state, isEditable: payload }),
		setNotePanelWidth: (state, { payload }) => {
			notesProvider.setNotesPanelWidth(payload);
			return { ...state, notesPanelWidth: payload };
		},
		setIsGenerating: (state, { payload }) => ({ ...state, isGenerating: payload }),
		setNewlyGeneratedNote: (state, { payload }) => ({ ...state, newlyGeneratedNote: payload }),
	},
});
export const {
	setSelectedNote,
	setIsSaving,
	setIsLoading,
	setIsEditable,
	setIsGenerating,
	setNotePanelWidth,
	setNewlyGeneratedNote,
} = noteSlice.actions;
export default noteSlice.reducer;
